export const getStoredLanguages = (fromStorageKey, toStorageKey) => {
  try {
    // Read From-related localStorage keys
    const storedFromVisible = JSON.parse(localStorage.getItem(fromStorageKey));
    console.log(`Reading ${fromStorageKey}:`, storedFromVisible);
    const storedFromSelected = JSON.parse(
      localStorage.getItem(`${fromStorageKey}_selected`)
    );
    console.log(`Reading ${fromStorageKey}_selected:`, storedFromSelected);

    // Read To-related localStorage keys
    const storedToVisible = JSON.parse(localStorage.getItem(toStorageKey));
    console.log(`Reading ${toStorageKey}:`, storedToVisible);
    const storedToSelected = JSON.parse(
      localStorage.getItem(`${toStorageKey}_selected`)
    );
    console.log(`Reading ${toStorageKey}_selected:`, storedToSelected);

    return {
      storedFromVisible,
      storedFromSelected,
      storedToVisible,
      storedToSelected,
    };
  } catch (error) {
    console.error("Error reading from localStorage:", error);
    return {
      storedFromVisible: null,
      storedFromSelected: null,
      storedToVisible: null,
      storedToSelected: null,
    };
  }
};
